/**
 * 노선 상태 색(목록 배지·노선 상세 공용). 값(`v_dispt.dispt_status`)은 데이터라 그대로, 색과 화면 글자만 여기서.
 *
 * #323(윤일향 「입찰 표기 색상으로 구분」) — 기사에게 공개된 「입찰」은 진한 파랑, 「비공개입찰」은 회색으로
 * 한눈에 갈리게 했다(예전엔 둘 다 옅은 색이라 섞여 보였다). 배차완료 진한 초록은 #207 그대로.
 */
export const DISPT_STATUS_TONE: Record<string, string> = {
  배차완료: 'bg-emerald-600 text-white', // #207 — 레거시 화면처럼 진한 초록(한눈에 갈리게)
  입찰: 'bg-blue-600 text-white',
  유찰가능: 'bg-amber-100 text-amber-800',
  유찰: 'bg-red-50 text-red-700',
  비공개입찰: 'bg-slate-200 text-slate-700',
  취소: 'bg-canvas text-ink-faint',
};

/** 상태 표기(#291) — 값(뷰가 계산한 '배차완료')은 그대로 두고 화면 글자만 '배차확정'으로. 필터도 값으로 보낸다. */
const STATUS_LABEL: Record<string, string> = { 배차완료: '배차확정', 입찰: '입찰(공개)' };
export const disptStatusLabel = (v: string) => STATUS_LABEL[v] ?? v;
